<template>
    <!-- Header -->
    <div class="flex flex-wrap relative py-2 md:py-2 w-full overflow-hidden">
        <div class="w-full rounded-xl overflow-hidden h-[249px] md:h-[360px] xl:h-[444px]" v-if="post.video">
            <div v-html="videoSchema"></div>
            <iframe
                id="ytplayer"
                type="text/html"
                class="w-full h-full aspect-video"
                :src="`https://www.youtube.com/embed/${post.video}?autoplay=1&controls=1&modestbranding=0&showinfo=0`"
                frameborder="0"
                allowfullscreen
            ></iframe>
        </div>
        <div class="w-full rounded-xl overflow-hidden h-48 md:h-64" v-else>
            <vue-picture
                v-if="headerImage || post.headerImage"
                :image="headerImage ? headerImage : post.headerImage"
                :style="'w-full h-full object-cover'"
                :name="post.title"
                :width="1400"
                :height="140"
                :notlazy="true"
                :fph="true"
            />
        </div>
    </div>
</template>

<script setup>
defineProps({
    post: {
        type: Object,
        required: true
    },
    headerImage: [Object, Boolean],
});
</script>
